<template>
  <b-button type="submit" variant="primary" size="lg" :disabled="disabled"><slot /></b-button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors.scss';

button {
  background-color: $darkBlue !important;
  outline: none;
  border: none;
  font-size: 1.4rem;
  opacity: 1 !important;
}
</style>
